import React from 'react'
import RaceColumn from './../RaceColumn/RaceColumn.component'

const CeoRace = () => {
  return <RaceColumn raceKey='ceo' title='Executive Race to the Royal Ring' subtitle='5MM Points (approx. $100MM AV)' />
}

export default CeoRace
